import { call, put, takeLatest, all } from 'redux-saga/effects';
import api from '../../../utils/tt-api';
import Actions, { ActionTypes } from './actions';
import notification from '@tt/components/Notification';
import { CONSTANT_VARIABLES } from '../../../views/common/Constant_Variables/constants';

function* fetchContainmentActionsLocations({ containmentactionlocationParams }) {
  try {
    yield put(Actions.setContainmentActionsLocationLoader({ containmentActionsLocationsLoader: true }));
    const { data } = yield call(api.get, {
      route: 'containmentLocation/getsearched',
      params: containmentactionlocationParams,
    });
    const containmentactionlocationData = data;
    yield put(Actions.setContainmentActionsLocations({ containmentactionlocationData }));
    yield put(Actions.setContainmentActionsLocationLoader({ containmentActionsLocationsLoader: false }));
  } catch (error) {
    yield put(Actions.setContainmentActionsLocationLoader({ containmentActionsLocationsLoader: false }));
    notification('error', error, '');
    console.warn(error); // Handle exception
  }
}

function* fetchContainmentActionsLocationById({ location }) {
  try {
    yield put(Actions.setContainmentActionsLocationLoader({ containmentActionsLocationsLoader: true }));
    const { data } = yield call(api.get, {
      route: 'ContainmentLocation/' + location,
    });
    const containmentActionsLocationById = data;
    yield put(Actions.setContainmentActionsLocationById({ containmentActionsLocationById }));
    yield put(Actions.setContainmentActionsLocationLoader({ containmentActionsLocationsLoader: false }));
  } catch (error) {
    yield put(Actions.setContainmentActionsLocationLoader({ containmentActionsLocationsLoader: false }));
    notification('error', error, '');
    console.warn(error); // Handle exception
  }
}

function* addUpdateContainmentActionsLocation({
  actionName,
  containmentActionsLocationsObj,
  containmentactionlocationParams,
}) {
  try {
    yield put(Actions.setContainmentActionsLocationLoader({ containmentActionsLocationsLoader: true }));
    const { data } = yield call(actionName === CONSTANT_VARIABLES.ADD ? api.post : api.put, {
      route: 'containmentlocation',
      data: containmentActionsLocationsObj,
    });
    const addUpdateContainmentActionsLocationObj = data;
    yield put(Actions.setaddUpdateContainmentActionsLocation({ addUpdateContainmentActionsLocationObj }));
    yield put(Actions.fetchContainmentActionsLocations({ containmentactionlocationParams }));
    notification(
      'success',
      actionName === CONSTANT_VARIABLES.ADD
        ? CONSTANT_VARIABLES.CONTAINMENT_ACTIONS_LOCATION_SUCCESS_ADD
        : CONSTANT_VARIABLES.CONTAINMENT_ACTIONS_LOCATION_SUCCESS_UPDATE,
      ''
    );
  } catch (error) {
    yield put(Actions.setContainmentActionsLocationLoader({ containmentActionsLocationsLoader: false }));
    notification('error', error, '');
    console.warn(error); // Handle exception
  }
}

function* deleteContainmentActionsLocation({ locationsId, containmentactionlocationParams }) {
  try {
    yield put(Actions.setContainmentActionsLocationLoader({ containmentActionsLocationsLoader: true }));
    yield call(api.delete, {
      route: 'ContainmentLocation/' + locationsId,
    });
    yield put(Actions.fetchContainmentActionsLocations({ containmentactionlocationParams }));
    notification('success', CONSTANT_VARIABLES.CONTAINMENT_ACTIONS_LOCATION_SUCCESS_DELETE, '');
  } catch (error) {
    yield put(Actions.setContainmentActionsLocationLoader({ containmentActionsLocationsLoader: false }));
    notification('error', error, '');
    console.warn(error); // Handle exception
  }
}

//Metric

function* fetchContainmentActionsMetrics({ containmentActionsMetricsParams }) {
  try {
    yield put(Actions.setContainmentActionsMetricLoader({ containmentActionsMetricLoader: true }));
    const { data } = yield call(api.get, {
      route: 'ContainmentMetrics/getsearched',
      params: containmentActionsMetricsParams,
    });
    const containmentactionmetricData = data;
    yield put(Actions.setContainmentActionsMetrics({ containmentactionmetricData }));
    yield put(Actions.setContainmentActionsMetricLoader({ containmentActionsMetricLoader: false }));
  } catch (error) {
    yield put(Actions.setContainmentActionsMetricLoader({ containmentActionsMetricLoader: false }));
    notification('error', error, '');
    console.warn(error); // Handle exception
  }
}

function* fetchContainmentActionsMetricsTypes() {
  try {
    const { data } = yield call(api.get, {
      route: `ContainmentMetrics/GetMetricsTypeList`,
    });
    const containmentactionmetricTypes = data;
    yield put(Actions.setContainmentActionsMetricsType({ containmentactionmetricTypes }));
  } catch (err) {
    notification('error', err, '');
    console.warn(err); // Handle exception
  }
}

function* fetchContainmentActionsMetricById({ metric }) {
  try {
    yield put(Actions.setContainmentActionsMetricLoader({ containmentActionsMetricLoader: true }));
    const { data } = yield call(api.get, {
      route: 'ContainmentMetrics/' + metric,
    });
    const containmentActionsMetricById = data;
    yield put(Actions.setContainmentActionsMetricById({ containmentActionsMetricById }));
    yield put(Actions.setContainmentActionsMetricLoader({ containmentActionsMetricLoader: false }));
  } catch (error) {
    yield put(Actions.setContainmentActionsMetricLoader({ containmentActionsMetricLoader: false }));
    notification('error', error, '');
    console.warn(error); // Handle exception
  }
}

function* fetchContainmentActionsStep3ById({ eightDProcessId }) {
  try {
    yield put(Actions.setContainmentActionsStep3Loader({ containmentActionsStep3Loader: true }));
    const { data } = yield call(api.get, {
      route: 'EightdProcess/ContainmentActionInterim?eightdProcessId=' + eightDProcessId,
    });

    yield put(Actions.setContainmentActionsStep3ById({ containmentActionsStep3: data }));
  } catch (error) {
    notification('error', error, '');
    console.warn(error); // Handle exception
  } finally {
    yield put(Actions.setContainmentActionsStep3Loader({ containmentActionsStep3Loader: false }));
  }
}

function* addUpdateContainmentActionsMetric({
  actionName,
  containmentActionsMetricsObj,
  containmentActionsMetricsParams,
}) {
  try {
    yield put(Actions.setContainmentActionsMetricLoader({ containmentActionsMetricLoader: true }));
    const { data } = yield call(actionName === CONSTANT_VARIABLES.ADD ? api.post : api.put, {
      route: 'ContainmentMetrics',
      data: containmentActionsMetricsObj,
    });
    const addUpdateContainmentActionsMetricObj = data;
    yield put(Actions.setaddUpdateContainmentActionsMetric({ addUpdateContainmentActionsMetricObj }));
    yield put(Actions.fetchContainmentActionsMetrics({ containmentActionsMetricsParams }));
    notification(
      'success',
      actionName === CONSTANT_VARIABLES.ADD
        ? CONSTANT_VARIABLES.CONTAINMENT_ACTIONS_METRIC_SUCCESS_ADD
        : CONSTANT_VARIABLES.CONTAINMENT_ACTIONS_METRIC_SUCCESS_UPDATE,
      ''
    );
  } catch (error) {
    yield put(Actions.setContainmentActionsMetricLoader({ containmentActionsMetricLoader: false }));
    notification('error', error, '');
    console.warn(error); // Handle exception
  }
}

function* deleteContainmentActionsMetric({ metricId, containmentActionsMetricsParams }) {
  try {
    yield put(Actions.setContainmentActionsMetricLoader({ containmentActionsMetricLoader: true }));
    yield call(api.delete, {
      route: 'ContainmentMetrics/' + metricId,
    });
    yield put(Actions.fetchContainmentActionsMetrics({ containmentActionsMetricsParams }));
    notification('success', CONSTANT_VARIABLES.CONTAINMENT_ACTIONS_METRIC_SUCCESS_DELETE, '');
  } catch (error) {
    yield put(Actions.setContainmentActionsMetricLoader({ containmentActionsMetricLoader: false }));
    notification('error', error, '');
    console.warn(error); // Handle exception
  }
}

function* fetchEightdNotAttached() {
  try {
    yield put(Actions.eightdNotAttachedLoader({ eightdNotAttachedLoader: true }));
    const { data } = yield call(api.get, {
      route: 'eightdprocess/EightDNotAttached',
    });
    const eightdNotAttachedData = data;
    yield put(Actions.setEightdNotAttached({ eightdNotAttachedData }));
    yield put(Actions.eightdNotAttachedLoader({ eightdNotAttachedLoader: false }));
  } catch (error) {
    yield put(Actions.eightdNotAttachedLoader({ eightdNotAttachedLoader: false }));
    notification('error', error, '');
    console.warn(error); // Handle exception
  }
}

function* fetchComplaintNotAttached() {
  try {
    yield put(Actions.complaintNotAttachedLoader({ complaintNotAttachedLoader: true }));
    const { data } = yield call(api.get, {
      route: 'complaint/GetComplaintNotAttached',
    });
    const complaintNotAttachedData = data;
    yield put(Actions.setComplaintNotAttached({ complaintNotAttachedData }));
    yield put(Actions.complaintNotAttachedLoader({ complaintNotAttachedLoader: false }));
  } catch (error) {
    yield put(Actions.complaintNotAttachedLoader({ complaintNotAttachedLoader: false }));
    notification('error', error, '');
    console.warn(error); // Handle exception
  }
}

// quality assurance complaint
function* fetchQualityAssuranceComplaint({ qualityAssuranceComplaintParams }) {
  try {
    yield put(Actions.setQualityAssuranceComplaintLoader({ qualityAssuranceComplaintLoader: true }));
    const { data } = yield call(api.get, {
      route: 'complaint/getsearched',
      params: qualityAssuranceComplaintParams,
    });
    const qualityAssuranceComplaintData = data;
    yield put(Actions.setQualityAssuranceComplaint({ qualityAssuranceComplaintData }));
    yield put(Actions.setQualityAssuranceComplaintLoader({ qualityAssuranceComplaintLoader: false }));
  } catch (error) {
    yield put(Actions.setQualityAssuranceComplaintLoader({ qualityAssuranceComplaintLoader: false }));
    notification('error', error, '');
    console.warn(error); // Handle exception
  }
}

// quality assurance complaint chart
function* fetchQualityAssuranceComplaintchart({ qualityAssuranceComplaintParams }) {
  try {
    yield put(Actions.setQualityAssuranceComplaintChartLoader({ qualityAssuranceComplaintChartLoader: true }));
    const { data } = yield call(api.get, {
      route: 'complaint/GetComplaintChart',
      params: qualityAssuranceComplaintParams,
    });
    const qualityAssuranceComplaintchartData = data;
    yield put(Actions.setQualityAssuranceComplaintChart({ qualityAssuranceComplaintchartData }));
    yield put(Actions.setQualityAssuranceComplaintChartLoader({ qualityAssuranceComplaintChartLoader: false }));
  } catch (error) {
    yield put(Actions.setQualityAssuranceComplaintChartLoader({ qualityAssuranceComplaintChartLoader: false }));
    notification('error', error, '');
    console.warn(error); // Handle exception
  }
}

function* fetchQualityAssuranceComplaintUniqueRef({ qualityAssuranceComplaintParams }) {
  try {
    yield put(Actions.setQualityAssuranceComplaintLoader({ qualityAssuranceComplaintLoader: true }));
    const { data } = yield call(api.get, {
      route: 'complaint/CheckComplaintRefNoExist',
      params: qualityAssuranceComplaintParams,
    });
    const qualityAssuranceComplaintUniqueData = data;
    yield put(Actions.setQualityAssuranceComplaintUniqueRef({ qualityAssuranceComplaintUniqueData }));
    yield put(Actions.setQualityAssuranceComplaintLoader({ qualityAssuranceComplaintLoader: false }));
  } catch (error) {
    yield put(Actions.setQualityAssuranceComplaintLoader({ qualityAssuranceComplaintLoader: false }));
    notification('error', error, '');
    console.warn(error); // Handle exception
  }
}

function* fetchQualityAssuranceEightDUniqueRef({ qualityAssuranceEightDParams }) {
  try {
    yield put(Actions.setQualityAssuranceComplaintLoader({ qualityAssuranceComplaintLoader: true }));
    const { data } = yield call(api.get, {
      route: 'eightdprocess/CheckEightDRefNoExist',
      params: qualityAssuranceEightDParams,
    });
    const qualityAssuranceEidghtDUniqueData = data;
    yield put(Actions.setQualityAssuranceEidghtDUniqueRef({ qualityAssuranceEidghtDUniqueData }));
    yield put(Actions.setQualityAssuranceComplaintLoader({ qualityAssuranceComplaintLoader: false }));
  } catch (error) {
    yield put(Actions.setQualityAssuranceComplaintLoader({ qualityAssuranceComplaintLoader: false }));
    notification('error', error, '');
    console.warn(error); // Handle exception
  }
}

// quality assurance complaint by factory
function* fetchQualityAssuranceComplaintfactory({ qualityAssuranceContactbyidParams }) {
  try {
    yield put(Actions.setQualityAssuranceComplaintLoader({ qualityAssuranceComplaintLoader: true }));
    const { data } = yield call(api.get, {
      route: 'complaint/GetComplaintFactory',
      params: qualityAssuranceContactbyidParams,
    });
    const qualityAssuranceContactbyidData = data;
    yield put(Actions.setQualityAssuranceComplaintFactory({ qualityAssuranceContactbyidData }));
    yield put(Actions.setQualityAssuranceComplaintLoader({ qualityAssuranceComplaintLoader: false }));
  } catch (error) {
    yield put(Actions.setQualityAssuranceComplaintLoader({ qualityAssuranceComplaintLoader: false }));
    notification('error', error, '');
    console.warn(error); // Handle exception
  }
}

function* fetchQualityAssuranceComplaintById({ complaintId }) {
  try {
    yield put(Actions.setQualityAssuranceComplaintLoader({ qualityAssuranceComplaintLoader: true }));
    const { data } = yield call(api.get, {
      route: 'complaint/' + complaintId,
    });
    const singleComplaintObj = data;
    yield put(Actions.setSingleComplaintObj({ singleComplaintObj }));
    yield put(Actions.setQualityAssuranceComplaintLoader({ qualityAssuranceComplaintLoader: false }));
  } catch (error) {
    yield put(Actions.setQualityAssuranceComplaintLoader({ qualityAssuranceComplaintLoader: false }));
    notification('error', error, '');
    console.warn(error); // Handle exception
  }
}

function* fetchComplaintFilesById({ complaintId }) {
  try {
    yield put(Actions.setQualityAssuranceComplaintFileLoader({ qualityAssuranceComplaintFileLoader: true }));
    const { data } = yield call(api.get, {
      route: 'complaint/getAllFiles/' + complaintId,
    });
    const filesUrl = data;
    yield put(Actions.setComplaintFiles({ filesUrl }));
  } catch (error) {
    notification('error', error, '');
    console.warn(error); // Handle exception
  } finally {
    yield put(Actions.setQualityAssuranceComplaintFileLoader({ qualityAssuranceComplaintFileLoader: false }));
  }
}

function* addUpdateQualityAssuranceComplaint({
  actionName,
  qualityAssuranceComplaintObj,
  qualityAssuranceComplaintParams,
}) {
  try {
    yield put(Actions.setQualityAssuranceComplaintLoader({ qualityAssuranceComplaintLoader: true }));
    qualityAssuranceComplaintObj.url = window.location.origin;
    const { data } = yield call(actionName === CONSTANT_VARIABLES.ADD ? api.post : api.put, {
      route: 'complaint',
      data: qualityAssuranceComplaintObj,
    });
    const qaCreatedUpdatedComplaintObj = data;
    yield put(Actions.setQACreatedUpdatedComplaintObj({ qaCreatedUpdatedComplaintObj }));
    yield put(Actions.fetchQualityAssuranceTilesData({ qualityAssuranceComplaintParams }));
    yield put(Actions.fetchQualityAssuranceComplaint({ qualityAssuranceComplaintParams }));
    yield put(Actions.fetchQualityAssuranceComplaintChart({ qualityAssuranceComplaintParams }));
    notification(
      'success',
      actionName === CONSTANT_VARIABLES.ADD
        ? CONSTANT_VARIABLES.Q_A_MANAGEMENT_COMPLAINT_SUCCESS_ADD
        : CONSTANT_VARIABLES.Q_A_MANAGEMENT_COMPLAINT_SUCCESS_UPDATE,
      ''
    );
  } catch (error) {
    yield put(Actions.setQualityAssuranceComplaintLoader({ qualityAssuranceComplaintLoader: false }));
    notification('error', error, '');
    console.warn(error); // Handle exception
  }
}

function* fetchQualityAssuranceEightdProcess({ qualityAssuranceEightdProcessParams }) {
  try {
    yield put(Actions.setQualityAssuranceEightdProcessLoader({ qualityAssuranceEightdProcessLoader: true }));
    const { data } = yield call(api.get, {
      route: 'eightdprocess/getsearched',
      params: qualityAssuranceEightdProcessParams,
    });
    const qualityAssuranceEightdProcessData = data;
    yield put(Actions.setQualityAssuranceEightdProcess({ qualityAssuranceEightdProcessData }));
    yield put(Actions.setQualityAssuranceEightdProcessLoader({ qualityAssuranceEightdProcessLoader: false }));
  } catch (error) {
    yield put(Actions.setQualityAssuranceEightdProcessLoader({ qualityAssuranceEightdProcessLoader: false }));
    notification('error', error, '');
    console.warn(error); // Handle exception
  }
}

function* fetchQualityAssuranceEightdProcessRef() {
  try {
    yield put(Actions.setQualityAssuranceEightdProcessLoader({ qualityAssuranceEightdProcessLoader: true }));
    const { data } = yield call(api.get, {
      route: 'eightdprocess/EightDProcessRefNo',
    });
    const qualityAssuranceEightdProcessRefData = data;
    yield put(Actions.setQualityAssuranceEightdProcessRef({ qualityAssuranceEightdProcessRefData }));
    yield put(Actions.setQualityAssuranceEightdProcessLoader({ qualityAssuranceEightdProcessLoader: false }));
  } catch (error) {
    yield put(Actions.setQualityAssuranceEightdProcessLoader({ qualityAssuranceEightdProcessLoader: false }));
    notification('error', error, '');
    console.warn(error); // Handle exception
  }
}

function* fetchQualityAssuranceEightdProcessById({ eightdProcessId }) {
  try {
    yield put(Actions.setQualityAssuranceEightdProcessLoader({ qualityAssuranceEightdProcessLoader: true }));
    const { data } = yield call(api.get, {
      route: 'eightdprocess/' + eightdProcessId,
    });
    const qualityAssuranceEightdProcessData = data;
    yield put(Actions.setQualityAssuranceEightdProcess({ qualityAssuranceEightdProcessData }));
    yield put(Actions.setQualityAssuranceEightdProcessLoader({ qualityAssuranceEightdProcessLoader: false }));
  } catch (error) {
    yield put(Actions.setQualityAssuranceEightdProcessLoader({ qualityAssuranceEightdProcessLoader: false }));
    notification('error', error, '');
    console.warn(error); // Handle exception
  }
}

function* addUpdateQualityAssuranceEightdProcess({
  actionName,
  qualityAssuranceEightdProcessObj,
  qualityAssuranceEightdProcessParams,
  isRefresh8DDashboard,
  callback,
}) {
  let containmentActionDocuments = qualityAssuranceEightdProcessObj.containmentActonsDocuments;
  const formData = new FormData();

  for (const [groupIndex, group] of qualityAssuranceEightdProcessObj.containmentActonsDocuments.entries()) {
    formData.append(`fileUploads[${groupIndex}].eightDProcessId`, qualityAssuranceEightdProcessObj.id);
    formData.append(`fileUploads[${groupIndex}].tabIndex`, group.tabIndex);
    formData.append(`fileUploads[${groupIndex}].rowIndex`, group.rowIndex ? group.rowIndex : 0);

    for (const fileItem of group.files) {
      formData.append(`fileUploads[${groupIndex}].files`, fileItem.originFileObj);
    }
  }

  delete qualityAssuranceEightdProcessObj.containmentActonsDocuments;

  try {
    const qualityAssuranceEightdProcessObjPayload = {
      eightDProcess: qualityAssuranceEightdProcessObj,
      stepSevenUpdatedDocsList: qualityAssuranceEightdProcessObj?.updatedDocsRowIndexesList,
    };

    yield put(Actions.setQualityAssuranceComplaintLoader({ qualityAssuranceComplaintLoader: true }));
    const { data } = yield call(actionName === CONSTANT_VARIABLES.ADD ? api.post : api.put, {
      route: 'eightdProcess',
      data:
        actionName === CONSTANT_VARIABLES.ADD
          ? qualityAssuranceEightdProcessObj
          : qualityAssuranceEightdProcessObjPayload,
    });
    const qaCreatedUpdatedEightdProcessObj = data;
    yield put(Actions.setQACreatedUpdatedEightdProcessObj({ qaCreatedUpdatedEightdProcessObj }));
    const filteredData = containmentActionDocuments.filter(item => item.files.length > 0);
    if (containmentActionDocuments && containmentActionDocuments?.length > 0 && filteredData.length > 0) {
      yield call(api.post, {
        route: `eightdprocess/UploadContainmentActionFiles`,
        data: formData,
      });
    }

    notification(
      'success',
      actionName === CONSTANT_VARIABLES.ADD
        ? CONSTANT_VARIABLES.Q_A_MANAGEMENT_EIGHT_D_PROCESS_SUCCESS_ADD
        : CONSTANT_VARIABLES.Q_A_MANAGEMENT_EIGHT_D_PROCESS_SUCCESS_UPDATE,
      ''
    );
    yield put(Actions.fetchQualityAssuranceEightdProcess({ qualityAssuranceEightdProcessParams }));
    if (callback) callback();
  } catch (error) {
    yield put(Actions.setQualityAssuranceComplaintLoader({ qualityAssuranceComplaintLoader: false }));
    notification('error', error, '');
    console.warn(error); // Handle exception
  }
}

function* addUpdateQualityAssuranceComplaintData({ actionName, complaintFormData, callback }) {
  let qaCreatedUpdatedComplaintObj;
  try {
    yield put(Actions.setQualityAssuranceComplaintLoader({ qualityAssuranceComplaintLoader: true }));
    if (complaintFormData) {
      const qualityAssuranceComplaintParams = {
        pageno: 1,
        searchText: '',
      };
      complaintFormData.url = window.location.origin;
      const { data } = yield call(actionName === CONSTANT_VARIABLES.ADD ? api.post : api.put, {
        route: 'complaint',
        data: complaintFormData,
      });
      qaCreatedUpdatedComplaintObj = data;
      yield put(Actions.setQACreatedUpdatedComplaintObj({ qaCreatedUpdatedComplaintObj }));
      yield put(Actions.fetchQualityAssuranceComplaint({ qualityAssuranceComplaintParams }));
      yield put(Actions.fetchQualityAssuranceComplaintChart({ qualityAssuranceComplaintParams }));
    }
    notification(
      'success',
      actionName === CONSTANT_VARIABLES.ADD
        ? CONSTANT_VARIABLES.Q_A_MANAGEMENT_COMPLAINT_SUCCESS_ADD
        : CONSTANT_VARIABLES.Q_A_MANAGEMENT_COMPLAINT_SUCCESS_UPDATE,
      ''
    );
    if (callback) callback(qaCreatedUpdatedComplaintObj?.toJS());
    yield put(Actions.setQualityAssuranceComplaintLoader({ qualityAssuranceComplaintLoader: false }));
  } catch (error) {
    yield put(Actions.setQualityAssuranceComplaintLoader({ qualityAssuranceComplaintLoader: false }));
    notification('error', error, '');
    console.warn(error); // Handle exception
  }
}

function* deleteQualityAssuranceComplaint({ complaintId, qualityAssuranceComplaintParams }) {
  try {
    yield put(Actions.setQualityAssuranceComplaintLoader({ qualityAssuranceComplaintLoader: true }));
    yield call(api.delete, {
      route: 'complaint/' + complaintId,
    });
    yield put(Actions.fetchQualityAssuranceComplaint({ qualityAssuranceComplaintParams }));
    yield put(Actions.fetchQualityAssuranceTilesData({ qualityAssuranceComplaintParams }));
    yield put(Actions.fetchQualityAssuranceComplaintChart({ qualityAssuranceComplaintParams }));
    notification('success', CONSTANT_VARIABLES.Q_A_MANAGEMENT_COMPLAINT_SUCCESS_DELETE, '');
  } catch (error) {
    yield put(Actions.setQualityAssuranceComplaintLoader({ qualityAssuranceComplaintLoader: false }));
    notification('error', error, '');
    console.warn(error); // Handle exception
  }
}

function* deleteQualityAssuranceEightdProcess({ id, qualityAssuranceEightdProcessParams }) {
  try {
    yield put(Actions.setQualityAssuranceComplaintLoader({ qualityAssuranceComplaintLoader: true }));
    yield call(api.delete, {
      route: 'eightdprocess/' + id,
    });
    yield put(Actions.fetchQualityAssuranceEightdProcess({ qualityAssuranceEightdProcessParams }));
    notification('success', CONSTANT_VARIABLES.Q_A_MANAGEMENT_COMPLAINT_SUCCESS_DELETE, '');
  } catch (error) {
    yield put(Actions.setQualityAssuranceComplaintLoader({ qualityAssuranceComplaintLoader: false }));
    notification('error', error, '');
    console.warn(error); // Handle exception
  }
}

function* uploadFilesEightdProcess({ actionName, fileList, eightdProcess }) {
  try {
    yield call(actionName === CONSTANT_VARIABLES.ADD ? api.post : api.put, {
      route: 'eightdprocess/UploadFiles/' + eightdProcess,
      data: fileList,
    });
    notification('success', CONSTANT_VARIABLES.FILE_UPLOADED_SUCCESSFULLY, '');
  } catch (error) {
    notification('error', error, '');
    console.warn(error); // Handle exception
  }
}

function* uploadFilesComplaint({ actionName, fileList, complaintId }) {
  try {
    yield call(actionName === CONSTANT_VARIABLES.ADD ? api.post : api.put, {
      route: 'complaint/UploadFiles/' + complaintId,
      data: fileList,
    });
    notification('success', CONSTANT_VARIABLES.FILE_UPLOADED_SUCCESSFULLY, '');
  } catch (error) {
    notification('error', error, '');
    console.warn(error); // Handle exception
  }
}

function* fetchQualityAssuranceTilesData({ qualityAssuranceComplaintParams }) {
  try {
    yield put(Actions.setQualityAssuranceEightdProcessLoader({ qualityAssuranceEightdProcessLoader: true }));
    const { data } = yield call(api.get, {
      route: 'eightdprocess/GetQualityAssuranceTileData',
      params: qualityAssuranceComplaintParams,
    });
    const qualityAssuranceTilesData = data;
    yield put(Actions.setQualityAssuranceTilesData({ qualityAssuranceTilesData }));
    yield put(Actions.setQualityAssuranceEightdProcessLoader({ qualityAssuranceEightdProcessLoader: false }));
  } catch (error) {
    yield put(Actions.setQualityAssuranceEightdProcessLoader({ qualityAssuranceEightdProcessLoader: false }));
    notification('error', error, '');
    console.warn(error); // Handle exception
  }
}

function* fetchFilesForDownload({ id, fileName }) {
  try {
    const { data } = yield call(api.get, {
      route: `eightdprocess/ContainmentActionFile/${id}/${fileName}`,
    });
    const downloadContainmentActionDocFile = data;
    yield put(Actions.setFilesForDownload({ downloadContainmentActionDocFile }));
    yield put(
      Actions.fetchQualityAssuranceEightdProcess({ qualityAssuranceEightdProcessParams: { pageno: 1, searchText: '' } })
    );
  } catch (err) {
    notification('error', err.toString(), '');
    console.warn(err); // Handle exception
  }
}

function* deleteContainmentActionDocFiles({ id, fileName }) {
  try {
    yield call(api.delete, {
      route: `eightdprocess/DeleteContainmentActionFile/${id}/${fileName}`,
    });
    notification('success', 'File Deleted Successfully!');
    yield put(
      Actions.fetchQualityAssuranceEightdProcess({ qualityAssuranceEightdProcessParams: { pageno: 1, searchText: '' } })
    );
  } catch (err) {
    notification('error', err.toString(), '');
    console.warn(err); // Handle exception
  }
}

export default function* rootSaga() {
  yield all([
    takeLatest(ActionTypes.FETCH_CONTAINMENT_ACTIONS_LOCATIONS, fetchContainmentActionsLocations),
    takeLatest(ActionTypes.FETCH_CONTAINMENT_ACTIONS_LOCATION_BY_ID, fetchContainmentActionsLocationById),
    takeLatest(ActionTypes.ADD_UPDATE_CONTAINMENT_ACTIONS_LOCATION, addUpdateContainmentActionsLocation),
    takeLatest(ActionTypes.DELETE_CONTAINMENT_ACTIONS_LOCATION, deleteContainmentActionsLocation),
    takeLatest(ActionTypes.FETCH_CONTAINMENT_ACTIONS_METRICS, fetchContainmentActionsMetrics),
    takeLatest(ActionTypes.FETCH_CONTAINMENT_ACTIONS_METRICS_TYPE_LIST, fetchContainmentActionsMetricsTypes),
    takeLatest(ActionTypes.FETCH_CONTAINMENT_ACTIONS_METRIC_BY_ID, fetchContainmentActionsMetricById),
    takeLatest(ActionTypes.ADD_UPDATE_CONTAINMENT_ACTIONS_METRIC, addUpdateContainmentActionsMetric),
    takeLatest(ActionTypes.DELETE_CONTAINMENT_ACTIONS_METRIC, deleteContainmentActionsMetric),

    takeLatest(ActionTypes.FETCH_CONTAINMENT_ACTIONS_STEP3_BY_ID, fetchContainmentActionsStep3ById),

    takeLatest(ActionTypes.FETCH_QUALITY_ASSURANCE_COMPLAINT, fetchQualityAssuranceComplaint),
    takeLatest(ActionTypes.FETCH_QUALITY_ASSURANCE_COMPLAINT_CHART, fetchQualityAssuranceComplaintchart),
    takeLatest(ActionTypes.FETCH_QUALITY_ASSURANCE_COMPLAINT_REf_UNIQUE, fetchQualityAssuranceComplaintUniqueRef),
    takeLatest(ActionTypes.FETCH_QUALITY_ASSURANCE_EightD_UNIQUE, fetchQualityAssuranceEightDUniqueRef),
    takeLatest(ActionTypes.FETCH_QUALITY_ASSURANCE_EIGHTDPROCESS_REF, fetchQualityAssuranceEightdProcessRef),
    takeLatest(ActionTypes.FETCH_QUALITY_ASSURANCE_COMPLAINT_FACTORY, fetchQualityAssuranceComplaintfactory),
    takeLatest(ActionTypes.ADD_UPDATE_QUALITY_ASSURANCE_COMPLAINT, addUpdateQualityAssuranceComplaint),
    takeLatest(ActionTypes.FETCH_QUALITY_ASSURANCE_COMPLAINT_FILES, fetchComplaintFilesById),
    takeLatest(ActionTypes.DELETE_QUALITY_ASSURANCE_COMPLAINT, deleteQualityAssuranceComplaint),
    takeLatest(ActionTypes.UPLOAD_FILES_COMPLAINT, uploadFilesComplaint),
    takeLatest(ActionTypes.UPLOAD_FILES_EIGHTDPROCESS, uploadFilesEightdProcess),
    takeLatest(ActionTypes.ADD_UPDATE_QUALITY_ASSURANCE_EIGHTDPROCESS, addUpdateQualityAssuranceEightdProcess),
    takeLatest(ActionTypes.FETCH_QUALITY_ASSURANCE_COMPLAINT_BY_ID, fetchQualityAssuranceComplaintById),
    takeLatest(ActionTypes.FETCH_QUALITY_ASSURANCE_EIGHTDPROCESS, fetchQualityAssuranceEightdProcess),
    takeLatest(ActionTypes.FETCH_QUALITY_ASSURANCE_EIGHTDPROCESS_BY_ID, fetchQualityAssuranceEightdProcessById),
    takeLatest(ActionTypes.FETCH_QUALITY_ASSURANCE_TILES_DATA, fetchQualityAssuranceTilesData),
    takeLatest(ActionTypes.DELETE_QUALITY_ASSURANCE_EIGHTDPROCESS, deleteQualityAssuranceEightdProcess),

    takeLatest(ActionTypes.FETCH_8D_NOT_ATTACHED, fetchEightdNotAttached),
    takeLatest(ActionTypes.FETCH_COMPLAINT_NOT_ATTACHED, fetchComplaintNotAttached),
    takeLatest(ActionTypes.ADD_UPDATE_QUALITY_ASSURANCE_COMPLAINT_DATA, addUpdateQualityAssuranceComplaintData),
    takeLatest(ActionTypes.FETCH_FILES_FOR_DOWNLOAD, fetchFilesForDownload),
    takeLatest(ActionTypes.DELETE_CONTAINMENT_DOC_FILES, deleteContainmentActionDocFiles),
  ]);
}
